import { createStyles, keyframes, rem } from '@mantine/core'

export const typeAnimate = keyframes({
  '0%': { transform: 'translateY(0px)' },
  '28%': { transform: 'translateY(-5px)' },
  '44%': { transform: 'translateY(0px)' },
})

export default createStyles((theme) => {
  return {
    root: {
      '& .cs-typing-indicator': {
        boxSizing: 'content-box',
        fontSize: '0.9em',
        display: 'flex',
        gap: rem(8),
        alignItems: 'stretch',

        '.indicator': {
          boxSizing: 'inherit',
          display: 'flex',
          alignItems: 'center',
        },

        '.dot': {
          boxSizing: 'inherit',
          animation: `${typeAnimate} 1.3s infinite ease-in-out`,
          borderRadius: '50%',
          display: 'inline-block',
          height: rem(4),
          width: rem(4),
          backgroundColor: theme.colors.blue[8],
        },
        '.dot:not(:last-child)': {
          marginRight: rem(3),
        },
        '.dot:nth-of-type(1)': {
          boxSizing: 'inherit',
        },
        '.dot:nth-of-type(2)': {
          animationDelay: '300ms',
        },
        '.dot:nth-of-type(3)': {
          animationDelay: '400ms',
        },
        '.text': {
          fontStyle: 'italic',
        },
      },
    },
  }
})
